import { __extends } from "tslib";
import React from 'react';
import throttle from 'lodash/throttle';
import { LoveMeterContext } from './LoveContext';
import { getPointsFromLoveScore, getLoveScoreFromPoints, isLove, midPoint, } from './redux/scales';
var freshLoveDelay = 1000;
var LoveMeter = /** @class */ (function (_super) {
    __extends(LoveMeter, _super);
    function LoveMeter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentLovePercentage: _this.props.hasLoved && _this.props.loveScore !== undefined
                ? getPointsFromLoveScore(_this.props.loveScore)
                : midPoint,
            isLoveInProgress: false,
            hasLoveChanged: false,
            justLoved: false,
            wasLove: _this.props.hasLoved && _this.props.loveScore > 0,
        };
        _this.toggleLove = throttle(function (isLoveInProgress) {
            return _this.setState({ isLoveInProgress: isLoveInProgress, hasLoveChanged: false });
        }, 300);
        _this.startLoving = function () {
            var onSliderOpen = _this.props.onSliderOpen;
            var _a = _this.state, currentLovePercentage = _a.currentLovePercentage, isLoveInProgress = _a.isLoveInProgress;
            // if already open, do nothing
            if (isLoveInProgress) {
                return;
            }
            if (currentLovePercentage !== undefined) {
                _this.setState({ wasLove: isLove(currentLovePercentage) });
            }
            _this.toggleLove(true);
            onSliderOpen && onSliderOpen();
        };
        _this.stopLoving = function () {
            var onSliderClose = _this.props.onSliderClose;
            var isLoveInProgress = _this.state.isLoveInProgress;
            if (!isLoveInProgress) {
                // nothing to do here
                return;
            }
            _this.toggleLove(false);
            onSliderClose && onSliderClose();
        };
        _this.updateLoveAmount = function (value) {
            // when the score is 0, snap to the middle point
            var snappedValue = getLoveScoreFromPoints(value) === 0 ? midPoint : value;
            _this.setState({
                currentLovePercentage: snappedValue,
                hasLoveChanged: _this.state.hasLoveChanged || value !== _this.state.currentLovePercentage,
                justLoved: false,
            });
        };
        _this.applyLove = function (value) {
            if (_this.loveTimeout) {
                clearTimeout(_this.loveTimeout);
            }
            var _a = _this.props, onChange = _a.onChange, itemId = _a.itemId, supportsRecommendations = _a.supportsRecommendations, loveCount = _a.loveCount;
            var wasLove = _this.state.wasLove;
            var loveScore = getLoveScoreFromPoints(value);
            _this.stopLoving();
            onChange(itemId, loveScore, supportsRecommendations && loveScore !== 0, loveCount);
            _this.setState({
                justLoved: isLove(value) && !wasLove,
                isLoveInProgress: false,
                hasLoveChanged: false,
                currentLovePercentage: value,
            });
            _this.loveTimeout = setTimeout(function () { return _this.setState({ justLoved: false }); }, freshLoveDelay);
        };
        _this.spreadLove = function (value) {
            var hasLoveChanged = _this.state.hasLoveChanged;
            // sometimes the bar interferes with the icon click
            // so if it's quickly clicked without moving at all,
            // assume it was meant to be a click
            if (!hasLoveChanged && getLoveScoreFromPoints(value) === 0) {
                _this.quickLove();
                return;
            }
            _this.applyLove(value);
        };
        _this.quickLove = function () {
            var hasLoved = _this.props.hasLoved;
            // if the user has already loved, reset love
            // if not, apply max amount
            _this.applyLove(getPointsFromLoveScore(hasLoved ? 0 : 5));
        };
        return _this;
    }
    LoveMeter.prototype.componentDidUpdate = function (prevProps) {
        var currentLovePercentage = this.state.currentLovePercentage;
        var _a = this.props, loveScore = _a.loveScore, hasLoved = _a.hasLoved, itemId = _a.itemId;
        // if itemId changed, we need a full reset
        if (itemId !== prevProps.itemId) {
            this.setState({
                currentLovePercentage: hasLoved && loveScore !== undefined
                    ? getPointsFromLoveScore(loveScore)
                    : midPoint,
                isLoveInProgress: false,
                hasLoveChanged: false,
                justLoved: false,
                wasLove: hasLoved && loveScore > 0,
            });
            return;
        }
        if (!hasLoved) {
            return;
        }
        // if the love score changed in a way that's no longer fit within
        // our scale, we need to update
        var currentLoveScore = getLoveScoreFromPoints(currentLovePercentage);
        if (prevProps.loveScore !== loveScore && currentLoveScore !== loveScore) {
            this.setState({
                currentLovePercentage: getPointsFromLoveScore(loveScore),
            });
        }
    };
    LoveMeter.prototype.render = function () {
        var _a = this.props, children = _a.children, hasLoved = _a.hasLoved, isMobile = _a.isMobile, isFirstLove = _a.isFirstLove;
        var _b = this.state, isLoveInProgress = _b.isLoveInProgress, hasLoveChanged = _b.hasLoveChanged, justLoved = _b.justLoved;
        return (React.createElement(LoveMeterContext.Provider, { value: {
                lovePercentage: this.state.currentLovePercentage,
                onLoveChanging: this.updateLoveAmount,
                onLoveChanged: this.spreadLove,
                onBeforeLoving: this.startLoving,
                onIconClick: isMobile ? this.startLoving : this.quickLove,
                onCancelLoving: this.stopLoving,
                isLoveInProgress: isLoveInProgress,
                hasLoveChanged: isLoveInProgress && hasLoveChanged,
                hasLoved: hasLoved,
                // a bit excessive safeguarding to make sure it's disabled while stuff is saving
                isFirstLove: isFirstLove && !justLoved && !hasLoved,
                justLoved: justLoved,
            } }, children));
    };
    return LoveMeter;
}(React.Component));
export { LoveMeter };
export default LoveMeter;
//# sourceMappingURL=LoveMeter.js.map